import React from "react";
import { reportWebsiteError } from "../monitoring/websiteErrors";

type SafeRenderBoundaryProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  storageKey?: string;
};

type SafeRenderBoundaryState = {
  hasError: boolean;
};

export class SafeRenderBoundary extends React.Component<
  SafeRenderBoundaryProps,
  SafeRenderBoundaryState
> {
  state: SafeRenderBoundaryState = { hasError: false };

  static getDerivedStateFromError(): SafeRenderBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    reportWebsiteError(error, this.props.storageKey || "MAIN_RENDER_ERROR");
    console.error("SafeRenderBoundary caught an error", error);
    if (!this.props.storageKey || typeof window === "undefined") {
      return;
    }
    window.localStorage.setItem(this.props.storageKey, error.message || "render_error");
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }

    return this.props.children;
  }
}
